import React, { useState, useRef, useContext } from "react";
import { Breadcrumb, SuccessPopupModal } from "../../Components/Atoms";
import "./style.css";
import { Image, Button, FormControl, FormLabel, Input, FormHelperText } from "@chakra-ui/react";
import { Title } from "../../Components/Atoms";
import { useNavigate } from "react-router-dom";
import { addDriver } from "../../APIs/index";
import { ProfileIcon } from "../../Assets/images/pngs";
import { StoreContext } from "../../Library/contexts";

import PATHS from "../../Routes/paths";

const breadcrumbPaths = [
  { idx: 1, name: "Lease", link: `/${PATHS.LEASE}` },
  { idx: 2, name: "Client Drivers", link: `${PATHS.LEASE}/${PATHS.DRIVERS}` },
  { idx: 3, name: "Add Drivers", link: "", isCurrentPage: true },
];

const driverDetsField = [
  { idx: 1, key: "dNm", nm: "Driver Name", placeholder: "Enter driver name" },
  { idx: 2, key: "mob", nm: "Contact Number", placeholder: "Enter driver contact", regex: /^[6-9]\d{9}$/ },
  { idx: 3, key: "dl", nm: "Driving Licence", placeholder: "Enter driving license no" },
  { idx: 4, key: "adhrNum", nm: "Aadhar number", placeholder: "Enter driver aadhar no", regex: /[0-9]{9,12}/ },
]

const AddDrivers = () => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const { filters } = useContext(StoreContext);

  const [fieldsFilled, setFieldsFilled] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [driverAdded, setDriverAdded] = useState({});
  const [driverDetails, setDriverDetails] = useState({ dNm: "", mob: "", dl: "", adhrNum: "", vid: "" });

  const [helperText, setHelperText] = useState("");

  const handleImageUpload = (e) => {
    if (!e.target.files || !e.target.files.length) return;

    setSelectedImage(e.target.files[0]);
  }

  const validateForm = () => {
    return driverDetsField.every(field => {
      if (!field || !driverDetails[field.key] || (field.regex && !driverDetails[field.key].match(field.regex))) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          [field.key]: `Invalid ${field.nm}`,
        }));

        return false;
      } else return true;
    })
  };


  const handleSubmit = () => {
    if (validateForm()) {
      addDriver({ ...driverDetails, clientId: filters.client }, selectedImage ? [ selectedImage ] : [])
      .then(() => {
        setDriverAdded({
          open: true,
          modalMsg: "Driver Added Successfully",
          closeBtn: "Okay",
          onModalClose: () => navigate(`${PATHS.LEASE}/${PATHS.DRIVERS}`),
        })
      })
      .catch(err => {
        setHelperText(err);
      });
    }
  }

  const handleInpChange = (e, field) => {
    if (field.showHelperTxt) return;

    const updatedDriverDetails = { ...driverDetails, [field.key]: e.target.value };
    setDriverDetails(updatedDriverDetails);
    setFormErrors(prevErrors => {
      return { ...prevErrors, [field.key]: null }
    })

    const allFieldsFilled = driverDetsField.every((field) => updatedDriverDetails[field.key].trim() !== "");
    setFieldsFilled(allFieldsFilled);
  };

  return (
    <main className="panel-card-center">
      <div className="drivers-header">
        <Breadcrumb className="bread-crumb" paths={breadcrumbPaths} />
      </div>
      <div className="container">
        <div className="profile-upload">
          <div className="profile-image-container">
            <Image src={selectedImage ? URL.createObjectURL(selectedImage) : ProfileIcon} resize={"contain"} className="profile-image" />
          </div>
          <Button onClick={() => fileInputRef.current.click()} className="upload-image-buttom">
            {selectedImage ? "Change Image" : "Upload Image"}
          </Button>
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleImageUpload}
          />
        </div>
        <div className="panel-main">
            <article className="panel-card">
              <Title>{"Driver Details"}</Title>
              <FormControl  isRequired>
                {driverDetsField.map((field, i) => <div key={i} className="driver-form" >
                  <FormLabel className={"driver-form-label"  + (field.showHelperTxt ? " margin-bottom25" : "")} >{field.nm}</FormLabel>
                  <div>
                    <Input className={formErrors[field.key] ? "error-class" : ""} placeholder={field.placeholder} value={driverDetails[field.key]} onChange={(e) => handleInpChange(e, field)} />
                    {formErrors[field.key] && <FormHelperText className="error-text">{formErrors[field.key]}</FormHelperText>}
                  </div>
                </div>)}
              </FormControl>

              {helperText ? <p className="error-helper"> { helperText } </p> : null}
            </article>
          <Button type="submit" onClick={handleSubmit} className={"add-model-button add-driver" + (!fieldsFilled ? " add-driver-disabled" : "")}>Add Driver</Button>
        </div>
        <SuccessPopupModal {...driverAdded} />
      </div>
    </main>
  );
};

export default AddDrivers;
